<coop-jatak-form
  [editMode]="false"
  [templateMode]="true"
  [offerId]="offerId"
  [formData]="formData"
  [previousUrl]="previousUrl"
  [successUrl]="successUrl"
  [jatakDefault]="jatakDefault"
></coop-jatak-form>
